<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="4">
          <v-card color="purple" dark>
            <v-card-title class="headline text-center">User Admin</v-card-title>
            <v-card-subtitle>Jumlah user level admin</v-card-subtitle>   
            <v-card-text class="display-2 text-center">{{adminCount}}</v-card-text>        
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card color="green" dark>
            <v-card-title class="headline text-center">User Operasional</v-card-title>
            <v-card-subtitle>Jumlah user level operasional</v-card-subtitle>   
            <v-card-text class="display-2 text-center">{{operasionalCount}}</v-card-text>        
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card color="orange" dark>
            <v-card-title class="headline text-center">User Rekanan</v-card-title>
            <v-card-subtitle>Jumlah user level vendor</v-card-subtitle>   
            <v-card-text class="display-2 text-center">{{vendorCount}}</v-card-text>        
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>


<script>

const API_URL = process.env.VUE_APP_ROOT_API
import axios from 'axios'


export default {
  data() {
    return {
      adminCount: 0,
      operasionalCount: 0,
      vendorCount: 0,
    }

  }, // data

  created() {
    axios.get(`${API_URL}/userman/roles`)
    .then( (response) => {
      const userRoles = response.data;
      console.log("User roles: ", userRoles);

      this.adminCount = 0;
      this.operasionalCount = 0;
      this.vendorCount = 0;

      userRoles.forEach(element => {
        if (element.roles === "adminit") this.adminCount++;
        else if (element.roles === "vendor") this.vendorCount++;
        else this.operasionalCount++;
      });

    })
    .catch( (error) => {
      console.error(error);
    });

  }, // created

}

</script>

<style>

</style>